import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";

// import vuetify from "./plugins/vuetify";
import "./assets/css/custom.css";

import vuetify from "./plugins/vuetify";

import { CAPTCHA_SITE_KEY } from "@/global/_constants";
import { reCaptchaPlugin } from "@/plugins/recaptchaPlugin";
import ipCheckPlugin from "@/plugins/ipCheckPlugin";
import ToastPlugin from './components/toast';
import ToastContainer from './components/ToastContainer.vue';
Vue.config.productionTip = false;

Vue.use(ipCheckPlugin);
Vue.use(reCaptchaPlugin, { siteKey: CAPTCHA_SITE_KEY });
Vue.use(ToastPlugin);
new Vue({
  router,
  store,
  vuetify,
components: { ToastContainer },
  // vuetify,
  render: (h) => h(App),
}).$mount("#app");
